module.exports = __webpack_public_path__ + "img/car-a.d059fc76.png";